import Vue from 'vue';
import Vuex from 'vuex';
import { encryptSetStorage, decryptGetStorage } from '@/libs/storage';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: decryptGetStorage('ltk'),
    userInfo: decryptGetStorage('usi'),
    account: decryptGetStorage('act')
  },
  mutations: {
    // 保存token
    SAVE_TOKEN (state, token) {
      state.token = token;
      encryptSetStorage('ltk', token);
    },
    // 保存密码
    SAVE_PASSWORD (state, account) {
      state.account = account;
      encryptSetStorage('act', account);
    },
    // 保存用户信息
    SAVE_USER: (state, user) => {
      state.userInfo = user;
      encryptSetStorage('usi', user);
    }
  },
  actions: {
  },
  modules: {
  }
});
